import style from "./App.module.scss";
import "./burger.css";

import { slide as Menu } from "react-burger-menu";
import red from "./images/menu_burger.svg";
import Info from "./components/Info/Info";
import Skills from "./components/Skills/Skills";
import Projects from "./components/Projects/Projects";
import Contacts from "./components/Contacts/Contacts";
import cls from "./components/Skills/Skills.module.scss";
import home from "./images/home.svg";
import skills from "./images/computer.svg";
import education from "./images/skills_5gavycb1qcik.svg";
import flagRu from "./images/russia_144dij0xz4cy.svg";
import flagEn from "./images/united_states_6wn5hj71yyi5.svg";

import work from "./images/work.svg";
import cnt from "./images/contact.svg";
import { useTranslation } from "react-i18next";
import Education from "./components/Education/Education";
import { useEffect, useState } from "react";
import Experience from "./components/Experience/Experience";
import task from "./images/task.svg";

function App() {
  const { t, i18n } = useTranslation();
  const [isOpen, setOpen] = useState(false);

  const getNormalizedLanguage = () => {
    const nav = window.navigator as Navigator & { userLanguage?: string };
    const lang = (nav.userLanguage || nav.language).toLowerCase();
    return lang.includes("ru") ? "ru" : "en";
  };

  const [useLanguage, setUseLanguage] = useState<string>(getNormalizedLanguage());

  function changeUserLanguage() {
    const nextLang = useLanguage === "en" ? "ru" : "en";
    setUseLanguage(nextLang);
    i18n.changeLanguage(nextLang);
  }

  useEffect(() => {
    i18n.changeLanguage(useLanguage);
  }, [useLanguage, i18n]);

  return (
    <div className={style.app}>
      <div id="outer-container" className={style.app__outerContainer}>
        <div className={style.app__buttonFlagsCover}>
          <button
            className={style.app__buttonFlags}
            onClick={() => changeUserLanguage()}
          >
            <img
              className={style.app__imgFlags}
              alt="flag"
              src={useLanguage === "ru" ? flagEn : flagRu}
            />
          </button>
        </div>
        <div className={style.app__menuBox}>
          <Menu
            isOpen={isOpen}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            customBurgerIcon={
              <img src={red} alt="img" className={style.app__menuImg} />
            }
            pageWrapId={"page-wrap"}
            outerContainerId={"outer-container"}
          >
            <a
              className={style.app__menuItem}
              href="#info"
              onClick={() => setOpen(false)}
            >
              <div className={cls.skills__box}>
                <img
                  className={cls.skills__img}
                  src={home}
                  id="home"
                  alt="home"
                />
                {t("Main")}
              </div>
            </a>
            <a
              className={style.app__menuItem}
              href="#projects"
              onClick={() => setOpen(false)}
            >
              <div className={cls.skills__box}>
                <img
                  className={cls.skills__img}
                  src={work}
                  id="work"
                  alt="work"
                />
                {t("Projects")}
              </div>
            </a>
            <a
              className={style.app__menuItem}
              href="#experience"
              onClick={() => setOpen(false)}
            >
              <div className={cls.skills__box}>
                <img
                  className={cls.skills__img}
                  src={task}
                  id="task"
                  alt="experience"
                />
                {t("Experience")}
              </div>
            </a>
            <a
              className={style.app__menuItem}
              href="#skills"
              onClick={() => setOpen(false)}
            >
              <div className={cls.skills__box}>
                <img
                  className={cls.skills__img}
                  src={skills}
                  id="skills2"
                  alt="skills1"
                />
                {t("Skills")}
              </div>
            </a>

            <a
              className={style.app__menuItem}
              href="#education"
              onClick={() => setOpen(false)}
            >
              <div className={cls.skills__box}>
                <img
                  className={cls.skills__img}
                  src={education}
                  id="Education"
                  alt="education"
                />
                {t("Education")}
              </div>
            </a>
            <a
              className={style.app__menuItem}
              href="#contact"
              onClick={() => setOpen(false)}
            >
              <div className={cls.skills__box}>
                <img className={cls.skills__img} src={cnt} id="cnt" alt="cnt" />
                {t("Contacts")}
              </div>
            </a>
          </Menu>
        </div>
        <nav className={style.app__nav}>

          <div className={style.app__menuItemBox} id="info">
            <Info />
          </div>
          <div className={style.app__menuItemBox} id="projects">
            <Projects />
          </div>
          <div className={style.app__menuItemBox} id="experience">
            <Experience />
          </div>
          <div className={style.app__menuItemBox} id="skills">
            <Skills />
          </div>
          <div className={style.app__menuItemBox} id="education">
            <Education />
          </div>
          <div className={style.app__menuItemBox} id="contact">
            <Contacts />
          </div>
        </nav>
      </div>
    </div>
  );
}

export default App;
